import { COLORS } from "../../utils/js/constants";

export default function authLoadingStyles(theme) {
  return {
    content: {
      height: '100vh',
      backgroundColor: COLORS.black61,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    title: {
      marginTop: 25,
      color: COLORS.lightYellow,
      fontSize: 20
    }
  }
}
